<template>
  <Modal v-model="sellingCountrySettingModal" :title="sellingCountrySettingTitle" :mask-closable="false"
    @on-visible-change="sellingCountrySettingChange" width="600">
    <Form :label-width="150" @submit.native.prevent>
      <Row type="flex">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1000374')" class="required_style_label">
            <vueTreeSelect
              style="width: 350px"
              :clearable="true"
              :searchable="true"
              :multiple="true"
              :noResultsText="$t('key1000102')"
              :noOptionsText="$t('key1000375')"
              :placeholder="$t('key1000101')"
              :normalizer="setNormalizer"
              :options="sellingCountrySettingList"
              v-model="countryCodes"
              :defaultExpandLevel="0"/>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="sellingCountrySettingModal=false">{{ $t('key1000112') }}</Button>
      <Button type="primary" :disabled="countryCodes.length <=0" @click="sellingCountrySettingBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getNationalContinentName, handleCountryContinentData, getAllCountrysData} from "@/utils/common";
import vueTreeSelect from "@riophae/vue-treeselect";

export default {
  name: 'sellingCountrySettingModal',
  mixins: [Mixin],
  props: {
    sellingCountrySettingData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    let v = this;
    return {
      sellingCountrySettingModal: false,
      sellingCountrySettingTitle: '',
      sellingCountrySettingList: [],
      countryCodes: [],
      supplierProductId: null,
      sellingCountrySettingType: null,
      setNormalizer(node) {
        return {
          id: node.twoCode,
          label: node.title,
          children: node.children
        };
      },
      continentCodeList: [],
    };
  },
  methods: {
    // 初始化数据
    initSellingCountrySettingData(type, supplierProductId, ymsProductId) {
      let obj = {
        setting: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000371'),
        edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000371')
      };
      this.sellingCountrySettingType = type;
      this.sellingCountrySettingTitle = obj[type];
      this.supplierProductId = supplierProductId;
      const handleData = () => {
        this.continentCodeList = this.sellingCountrySettingList.map((item) => {
          return item.twoCode;
        });
        if (type === 'edit') {
          this.axios.get(api.get_ymsProductSaleCountry_queryYmsProductSaleCountry + ymsProductId).then((response) => {
            if (response.data.code === 0) {
              let data = response.data.datas || [];
              if (data.length > 0) {
                let countryCodes = data.map((item) => item.countryCode);
                this.countryCodes = getNationalContinentName(countryCodes, this.sellingCountrySettingList, 'code');
              }
            }
          });
        }
        this.sellingCountrySettingModal = true;
      };
      if (this.sellingCountrySettingData.length > 0) {
        this.sellingCountrySettingList = JSON.parse(JSON.stringify(this.sellingCountrySettingData));
        handleData();
      } else {
        getAllCountrysData('cn', true).then((data) => {
          this.sellingCountrySettingList = handleCountryContinentData(data);
          handleData();
        });
      }
    },
    // 确定
    sellingCountrySettingBtn() {
      let countryCodes = [];
      this.countryCodes.map((value) => {
        this.sellingCountrySettingList.map((ele) => {
          if (value === ele.twoCode) {
            let list = ele.children.map((k) => {
              return k.twoCode;
            });
            countryCodes.push(...list);
          } else {
            if (!this.continentCodeList.includes(value)) {
              countryCodes.push(value);
            }
          }
        });
      });
      let countryCodesList = this.uniqueFunc(countryCodes);
      let query = {
        countryCodes: countryCodesList,
        supplierProductIds: Array.isArray(this.supplierProductId) ? this.supplierProductId : [this.supplierProductId]
      };
      this.axios.post(api.post_ymsProductSaleCountry_batchSetSaleCountry, query,
        {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          this.sellingCountrySettingModal = false;
          if (this.sellingCountrySettingType !== 'edit') {
            this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000372'));
          } else {
            this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000373'));
          }
          this.$nextTick(() => {
            this.$emit('updateData', true);
          });
        }
      });
    },
    // 监听弹窗
    sellingCountrySettingChange(value) {
      if (!value) {
        this.countryCodes = [];
        this.supplierProductId = null;
        this.sellingCountrySettingList = [];
      }
    }
  },
  components: {
    vueTreeSelect
  }
};
</script>

<style lang="less">

</style>
